import '@fancyapps/fancybox/dist/jquery.fancybox.min';
import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/popover';
import 'bootstrap/js/src/tooltip';
import 'bootstrap/js/src/modal';
import Modernizr from 'modernizr';
import LazyLoad from "vanilla-lazyload";

export default class Utils {

	constructor() {
		Utils.click();
		Utils.bootstrap();
		Utils.fancybox();
		Utils.searchbox();
		Utils.smooth_scroll();
		Utils.lazy();
		Utils.block_cover();
		Utils.obfuscation();
		Utils.sticky_navbar();
		Utils.show_more();
		Utils.flash_info_close();
		Utils.flash_info_marquee();
		Utils.toggle_collapse();
		Utils.burger_menu();
		Utils.setCookie("flashinfo", "show", 1)
	}

	static click() {
		const trigger = '[data-trigger="wpiris-click"]';

		if (!Modernizr.touchevents) {
			let ctrl = 0;
			$(window).on('keydown', function (e) {
				if (e.which === 17 || e.which === 91) {
					ctrl = true
				}
			})
			$(window).on('keyup', function () {
				ctrl = false
			})

			$(document).on('mouseup', trigger, function (e) {

				if (e.target.tagName.toLowerCase() !== 'a') {
					if (e.which === 1 || e.which === 2) {
						let blank = false
						let url = $(this).find("a").attr("href")
						if (e.which === 2) {
							blank = true
						} // Clic molette
						if ($(this).find("a").attr("target") === "_blank") {
							blank = true
						}
						if (blank || ctrl) {
							window.open(url, '_blank')
						} else {
							window.location = url
						}
						return false
					}
				}
				return false

			})
		} else {
			$(document).on('click', trigger, function (e) {

				let blank = false
				let url = $(this).find("a").attr("href")
				if ($(this).find("a").attr("target") === "_blank") {
					blank = true
				}
				if (blank) {
					window.open(url, '_blank')
				} else {
					window.location = url
				}
				return false

			})
		}
	}

	static bootstrap() {
		if (!Modernizr.touchevents) {
			$('[data-toggle="tooltip"]').tooltip({trigger: "hover"})
		}

		$('[data-toggle="popover"]').popover();
	}

	static fancybox() {

		$('.hentry a:has(>img):not([target="_blank"]):not("[nofancybox]")').each(function () {

			const href = $(this).attr('href');

			if (href.match(/(.jpg|.jpeg|.png|.gif|.svg|.webp)$/)) {
				$(this).attr('data-fancybox', 'fancybox');
			} else {
				if (href.indexOf(Theme.server_url) === -1) {
					$(this).attr('target', '_blank');
				}
			}
		});


		let counter = 0;
		$('.hentry .wp-block-gallery').each(function () {
			counter++;
			$(this).find('a:has(>img)').attr('data-fancybox', 'wp-block-gallery-' + counter);
		});

		counter = 0;
		$('.hentry .wp-block-image').each(function () {
			counter++;
			$(this).find('a:has(>img)').attr('data-fancybox', 'wp-block-image-' + counter);
		});

		$('[data-fancybox]').fancybox({
			buttons: [
				"zoom",
				"slideShow",
				"close"
			],
			backFocus: false,
			lang: "fr",
			i18n: {
				fr: {
					CLOSE: Theme.translate.fancybox_close,
					NEXT: Theme.translate.fancybox_next,
					PREV: Theme.translate.fancybox_prev,
					ERROR: Theme.translate.fancybox_error,
					PLAY_START: Theme.translate.fancybox_start,
					PLAY_STOP: Theme.translate.fancybox_stop,
					FULL_SCREEN: Theme.translate.fancybox_full_screen,
					THUMBS: Theme.translate.fancybox_thumbs,
					DOWNLOAD: Theme.translate.fancybox_download,
					SHARE: Theme.translate.fancybox_share,
					ZOOM: Theme.translate.fancybox_zoom
				},
			},
			caption: function (instance, item) {
				let caption = $(this).closest('figure').find('figcaption').html()

				if (!caption) {
					caption = $(this).find('img').attr('title')
				}

				if (!caption) {
					caption = $(this).find('img').attr('alt')
				}

				return caption
			}
		})
	}

	static searchbox() {
		const trigger = '[data-trigger="wpiris-search-layout"]',
			close = '[data-trigger="wpiris-search-layout-close"]',
			$element = $('[data-id="wpiris-search-layout"]');

		$(document).on('click', trigger, function (e) {
			e.preventDefault();
			$element.fadeIn().find('input').focus();
		})

		$(document).on('click', close, function (e) {
			e.preventDefault();
			$element.fadeOut();
		})
	}

	static smooth_scroll() {
		const trigger = '[data-trigger="wpiris-scroll"]';

		$(document).on('click', trigger, function (e) {
			e.preventDefault();

			const target = $(this).attr("href") != '' ? $(this).attr("href") : $(this).attr("data-href"),
				duration = 1000,
				scroll_top = $(target).offset().top - (undefined !== e.currentTarget.dataset.shift ? e.currentTarget.dataset.shift : 0);

			$('html, body').animate({
				scrollTop: scroll_top
			}, {
				duration: duration,
				step: (now, fx) => {
					let real_pos = scroll_top;
					if (fx.end !== real_pos) {
						fx.end = real_pos;
					}
				}
			});
		})
	}

	static lazy() {
		const lazyLoadInstance = new LazyLoad({
			elements_selector: '[data-src], [data-bg], [data-bg-hidpi]'
		});
		window.onbeforeprint = function () {
			lazyLoadInstance.loadAll();
		};
	}

	static block_cover() {
		$('.wp-block-cover:has(.wp-block-cover__inner-container a)').attr('data-trigger', 'wpiris-click')
	}

	static obfuscation() {
		let element = "[data-obf]";
		if ($(element).length > 0) {
			if (!Modernizr.touchevents) {
				let ctrl = 0;
				$(window).on('keydown', function (e) {
					if (e.which == 17 || e.which == 91) {
						ctrl = true;
					}
				});
				$(window).on('keyup', function () {
					ctrl = false;
				});

				$(document).on('mouseup', element, function (e) {
					let url = atob($(this).attr('data-obf'));
					let target = $(this).attr('data-obf-target');
					if (e.which == 1 || e.which == 2) {
						let blank = false;
						if (e.which == 2) {
							blank = true;
						} // Clic molette
						if (target == "_blank") {
							blank = true;
						}
						if (blank || ctrl) {
							window.open(url, '_blank');
						} else {
							window.location = url;
						}
						return false;
					}

					return false;

				});
			} else {
				$(document).on('click', element, function (e) {
					let blank = false;
					let url = atob($(this).attr('data-obf'));
					let target = $(this).attr('data-obf-target');
					if (target == "_blank") {
						blank = true;
					}
					if (blank) {
						window.open(url, '_blank');
					} else {
						window.location = url;
					}
					return false;
				});
			}
		}
	}

	static sticky_navbar() {

		let last_scroll = 0,
			direction = null,
			trigger_height = $('.navbar').outerHeight(),
			$element = $('.navbar');

		// On scroll
		$(window).scroll(function () {

			let scroll = $(window).scrollTop();

			// Determine wich direction
			if (scroll > last_scroll) {
				direction = 'bottom';
				last_scroll = scroll;
			} else {
				direction = 'top';
				last_scroll = scroll;
			}

			// Set sticky when scroll up
			if ((direction == "bottom") && (scroll > trigger_height)) {
				$element.removeClass('is-sticky');
				$element.addClass('is-hidden');
			} else {
				$element.addClass('is-sticky');
				$element.removeClass('is-hidden');
			}

			// Remove class if scroll top
			if (scroll == '0') {
				$element.removeClass('is-sticky');
			}
		});
	}

	static show_more() {
		let trigger = "[data-trigger='wpiris-show-more']";

		$(document).on('click', trigger, function (e) {
			e.preventDefault();
			let attr = $(this).attr('href');
			$(attr).toggleClass('show');
			$(this).hide();
		});
	}

	static setCookie(cname, cvalue, exdays) {
		const d = new Date();
		d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
		const expires = `expires=${d.toUTCString()}`;

		document.cookie = `${cname}=${cvalue};${expires};path=/`;
	}

	static getCookie(cname) {
		const name = `${cname}=`;
		const decodedCookie = decodeURIComponent(document.cookie);
		const ca = decodedCookie.split(';');
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) === ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) === 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}

	static flash_info_close() {
		const $bodyHasFlashInfo = $('body.has-flash-info'),
			$flashInfo = $('.flash-info'),
			$flashInfoCloseBtn = $('.flash-info__close');

		$flashInfoCloseBtn.on('click', function () {
			$bodyHasFlashInfo.removeClass('has-flash-info');
			$flashInfo.fadeOut(200);
			Utils.setCookie("flashinfo", "hide", 1);
		})
	}

	static flash_info_marquee() {
		if ("hide" === Utils.getCookie("flashinfo")) {
			$('body').removeClass('has-flash-info');
		}

		// Marquee info live message
		const $flashInfoItems = $('.flash-info__items'),
			$flashInfoMessage = $('.flash-info__message');
		let flashInfoDelay = 20,
			flashInfoSpeed = 2,
			flashInfoTimer = null;

		if (window.matchMedia("(max-width: 650px)").matches) {
			flashInfoSpeed = 0.8;
		}

		if ($flashInfoItems.length) {
			checkSlideable();

			$(window).on('resize', function () {
				clearTimeout(flashInfoTimer);
				checkSlideable();
			});
		}

		$flashInfoItems.on('mouseenter', function () {
			clearTimeout(flashInfoTimer);
		});

		$flashInfoItems.on('mouseleave', function () {
			if ($flashInfoMessage.outerWidth() > $flashInfoItems.outerWidth()) {
				scrollFlashInfo();
			} else {
				clearTimeout(flashInfoTimer);
				$flashInfoMessage.css({
					left: '10px'
				});
			}
		});

		function checkSlideable() {

			if ($flashInfoMessage.outerWidth() > $flashInfoItems.outerWidth()) {
				$flashInfoMessage.css({
					left: $flashInfoItems.outerWidth()
				});

				scrollFlashInfo();
			} else {
				clearTimeout(flashInfoTimer);
				$flashInfoMessage.css({
					left: '10px'
				});
			}
		}

		function scrollFlashInfo() {

			if ($flashInfoMessage.position().left > -($flashInfoMessage.outerWidth())) {
				$flashInfoMessage.css({
					left: $flashInfoMessage.position().left - flashInfoSpeed
				});
			} else {
				$flashInfoMessage.css({
					left: $flashInfoItems.outerWidth()
				});
			}

			flashInfoTimer = setTimeout(function () {
				scrollFlashInfo()
			}, flashInfoDelay);
		}
	}

	static toggle_collapse() {
		const textTrigger = '[data-toggle="collapse"]';

		$(textTrigger).on('click', function () {
			$(this).toggleClass("is-open");
		})
	}

	static burger_menu() {
		const burgerMenu = '[data-trigger="burger-menu"]';
		const submenuListItem = '[data-list-item]';
		const submenuBtnForward = '[data-more-menu]';
		const submenuBtnBackward = '[data-trigger="wpiris-menu-back"]';
		const $body = $('body');

		$(burgerMenu).on('click', function () {
			if ($body.hasClass('menu-open')) {
				$(submenuListItem).removeClass('submenu-open');
			}

			$body.toggleClass('menu-open');
		});

		$(submenuBtnForward).on('click', function () {
			$(this).parent().addClass('submenu-open');
		})

		$(submenuBtnBackward).on('click', function () {
			$(submenuListItem).removeClass('submenu-open');
		})
	}
}
